import useCrud from 'hooks/useCrud';
import { useCallback, useState } from 'react';
import { taskList, TaskListParams } from './api';

const defaultPage = {
  current: 1,
  pageSize: 10,
  total: 0,
};

function useTaskList() {
  const [page, setPage] = useState(defaultPage);

  const crud = useCrud({
    readList: useCallback(
      (params: Util.PartialPartial<TaskListParams, 'keyword' | 'pageNum' | 'pageSize'>) => {
        return taskList({
          pageNum: defaultPage.current,
          pageSize: defaultPage.pageSize,
          ...params,
          keyword: params.keyword || '',
        }).then((res) => {
          const {
            pages: { pageNum: current, pageSize, totalRows: total },
            data,
          } = res;

          setPage({
            current,
            pageSize,
            total,
          });

          return data;
        });
      },
      [],
    ),
  });

  return {
    ...crud,
    page,
    setPage,
  };
}

export default useTaskList;
